export default __webpack_public_path__ + "static/media/GigLinked_Illustrations_looking-for-musician.b1008c99.svg";